export default["__VITE_ASSET__skO3rjjP__","__VITE_ASSET__8E_c1zxf__"];